"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class OverlayClickHandler {
    constructor(ui) {
        this.ui = ui;
        this.ui.overlay.addEventListener('click', event => this.handleEvent(event));
    }
    onClick(handler) {
        this.handler = handler;
    }
    handleEvent(event) {
        if (event.target === this.ui.overlay && this.handler !== undefined) {
            this.handler();
        }
    }
}
exports.default = OverlayClickHandler;
//# sourceMappingURL=OverlayClickHandler.js.map